<template>
  <div id="app">
    <!-- Preview mode banner -->
    <div v-if="isPreview" class="cms-preview-bar">
      <span><i class="fa fa-eye"></i> <strong>Preview mode</strong> — this is a draft, not the live page.</span>
      <a :href="currentPathWithoutPreview" class="cms-preview-bar__exit">Exit preview</a>
    </div>
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view />
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
import { FadeTransition } from "vue2-transitions";
import { isPreview } from "@/services/cms";

export default {
  components: { FadeTransition },
  computed: {
    isPreview() { return isPreview(); },
    currentPathWithoutPreview() {
      const u = new URL(window.location.href);
      u.searchParams.delete('preview');
      u.searchParams.delete('token');
      u.searchParams.delete('page');
      return u.toString();
    },
  },
  mounted() {
    if (localStorage.getItem("access")) {
      this.$axios
        .post("verify/", { token: localStorage.getItem("access") })
        .then(res => {
          if (res) {
            this.$axios.defaults.headers.common = {
              Authorization: "Bearer " + this.$store.getters.access
            };
          }
        })
        .catch(err => {
          if (err.response) {
            this.$store.dispatch("logout");
            delete this.$axios.defaults.headers.common["Authorization"];
          }
        });
    }
  }
};
</script>
<style>
.ntt {
  /*no text transform  */
  text-transform: none !important;
}
/* Sticky footer layout */
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
/* Reset legacy argon-theme rules on main */
main {
  position: relative !important;
  float: none !important;
  z-index: auto !important;
  overflow: visible !important;
  height: auto !important;
  width: 100% !important;
  display: block !important;
  margin-top: 0 !important;
  padding-top: 64px !important;
  flex: 1 !important;
}
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap");

.cms-preview-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #575ECF;
  color: #fff;
  padding: 10px 24px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  box-shadow: 0 -2px 12px rgba(0,0,0,0.15);
}
.cms-preview-bar__exit {
  color: #fff;
  text-decoration: underline;
  font-size: 12px;
  white-space: nowrap;
}
.cms-preview-bar__exit:hover { opacity: 0.8; }
</style>
